import React, { useState } from 'react';
import styled from 'styled-components';
import api from '../services/api';

// Styled Components
const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f0f2f5;
  padding: 2rem;
`;

const Card = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 500px;
`;

const Title = styled.h2`
  color: #333;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const FormGroup = styled.div`
  margin-bottom: 1rem;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: #555;
  font-weight: bold;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  box-sizing: border-box;
`;

const Button = styled.button`
  width: 100%;
  padding: 1rem;
  background-color: #043663;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1.1rem;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.7 : 1};
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background: ${props => props.disabled ? '#ccc' : '#032a4a'};
  }
`;

const Status = styled.div`
  padding: 1rem;
  border-radius: 4px;
  margin-top: 1rem;
  background: ${props => props.$success ? '#d4edda' : '#f8d7da'};
  color: ${props => props.$success ? '#155724' : '#721c24'};
  border: 1px solid ${props => props.$success ? '#c3e6cb' : '#f5c6cb'};
`;

const TestCheckoutPage = () => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [formData, setFormData] = useState({
    teamName: 'Test Team',
    email: 'test@example.com',
    canton: 'ZH'
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setStatus('');

    try {
      // 1. Register team for current season
      const registrationResponse = await api.post('/seasons/register-team', formData);
      
      if (!registrationResponse.data.success) {
        setStatus(`Registration failed: ${registrationResponse.data.message}`);
        setLoading(false);
        return;
      }

      const { registration_id } = registrationResponse.data.data;

      // 2. Create Stripe Checkout Session
      const checkoutResponse = await api.post('/payments/create-checkout-session', {
        registration_id: registration_id,
        success_url: `${window.location.origin}/dashboard?payment=success&session_id={CHECKOUT_SESSION_ID}`,
        cancel_url: `${window.location.origin}/dashboard?payment=cancelled`
      });

      if (!checkoutResponse.data.success) {
        setStatus(`Checkout creation failed: ${checkoutResponse.data.message}`);
        setLoading(false);
        return;
      }

      // 3. Redirect to Stripe Checkout
      const { checkout_url } = checkoutResponse.data.data;
      window.location.href = checkout_url;

    } catch (error) {
      console.error('Error:', error);
      setStatus(`Error: ${error.response?.data?.message || error.message}`);
      setLoading(false);
    }
  };

  return (
    <PageContainer>
      <Card>
        <Title>Test Stripe Checkout</Title>
        
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="teamName">Team Name</Label>
            <Input
              type="text"
              id="teamName"
              name="teamName"
              value={formData.teamName}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="email">Email</Label>
            <Input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="canton">Canton</Label>
            <Input
              type="text"
              id="canton"
              name="canton"
              value={formData.canton}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <Button type="submit" disabled={loading}>
            {loading ? 'Processing...' : 'Pay with Stripe Checkout'}
          </Button>

          {status && (
            <Status $success={status.includes('success')}>
              {status}
            </Status>
          )}
        </form>

        <div style={{ marginTop: '2rem', padding: '1rem', background: '#f8f9fa', borderRadius: '4px' }}>
          <h3>What happens next:</h3>
          <ol>
            <li>Click "Pay with Stripe Checkout"</li>
            <li>You'll be redirected to Stripe's secure checkout page</li>
            <li>Enter your billing address and card details</li>
            <li>Complete the payment</li>
            <li>You'll be redirected back to your dashboard</li>
          </ol>
          
          <h3>Test Card Numbers:</h3>
          <ul>
            <li><strong>Success:</strong> 4242 4242 4242 4242</li>
            <li><strong>Decline:</strong> 4000 0000 0000 0002</li>
            <li><strong>Any future date:</strong> 12/34</li>
            <li><strong>Any CVC:</strong> 123</li>
          </ul>
        </div>
      </Card>
    </PageContainer>
  );
};

export default TestCheckoutPage;
